export const getHttpMethod = (id: string | number): 'put' | 'post' => {
  if (id) return 'put';
  return 'post';
};
